module.exports = __webpack_public_path__ + "static/media/Logo_ido-data_Couleurs_2020_WEB.da66fd47.png";